<template>
  <section class="order-slip">
    <div class="columns">
      <div class="column">
        <h1 class="title is-4"> {{tabActive == 0 ?'陸送発注票':'陸送受注票'}}</h1>
        <h2 class="title is-5">{{ transporterName }} 御中</h2>
      </div>
      <div class="column">
        <div class="container has-text-right">
          <div class="is-size-6 mb-3">
            {{ today }}
          </div>
          <h3 class="title is-6 mb-2">株式会社ジャパン・キャリアー</h3>
          <div>〒135-0044 東京都江東区越中島1-2-13TK門前仲町ビル7F</div>
          <div>TEL: 03-5875-9239 FAX: 03-6774-7327</div>
          <div>担当: {{ user.displayName }}</div>
        </div>
      </div>
    </div>
    <div @click="showMemo" class="v-icon-memo">
      <b-icon v-show="!isShowMemo" size="is-medium" pack="fa" icon="caret-down">
      </b-icon>
      <b-icon v-show="isShowMemo" size="is-medium" pack="fa" icon="caret-up">
      </b-icon>
    </div>
    <div class="v-input-memo" v-show="isShowMemo">
      <b-field label="Memo">
        <textarea
          class="v-input-textarea"
          @input="autoResize()"
          ref="textarea"
        ></textarea>
      </b-field>
    </div>
    <b-field>
      <b-table
        :data="this.vendor.items"
        class="has-text-weight-bold is-size-6"
        bordered
        :mobile-cards="false"
      >
        <b-table-column v-slot="props" width="10">
          <div class="order-slip-list-data">
            {{ props.index + 1 }}
          </div>
        </b-table-column>
        <b-table-column
          label="引取先 #号車(POS)"
          field="transportFromName"
          v-slot="props"
        >
          <div class="order-slip-list-data" v-if="props.row.isOpenSearchAddressByZipCodePopupFlag">
            <span v-if="props.row.suppliersName"
              >{{ (props.row.suppliersName) }}</span
            >
            <br />
            <span v-if="props.row.addressByZipcode"> {{ props.row.addressByZipcode }}</span>
          </div>

          <div class="order-slip-list-data" v-if="!props.row.isOpenSearchAddressByZipCodePopupFlag">
            {{ props.row.transportFromName
            }}
            <span v-if="props.row.transportRequestChange == 'true'"
              >&nbsp;&nbsp;{{ conpanyNameYardVendor(props.row) }}</span
            >
            <br />
            <span v-if="props.row.lotNo"> #{{ props.row.lotNo }}</span>
            <br />
            <span>{{ posNumber(props.row) }}</span>
            <br />
            <span>{{ posAccount(props.row) }}</span>
            {{ props.row.transportFromAddress }}
          </div>
        </b-table-column>
        <b-table-column label="納車先" v-slot="props">
          <div class="order-slip-list-data">
            {{ props.row.transportToName ? props.row.transportToName : ''}}
            <br />
            {{ props.row.handlingCompanyJp ? props.row.handlingCompanyJp + ' 扱い' : '' }}
            {{ props.row.customerName ? props.row.customerName + ' 分' : '' }}
            <br />
            <span>
              {{ props.row.transportToAddress }}
            </span>
          </div>
        </b-table-column>
        <b-table-column label="車両" field="model" v-slot="props">
          <div class="order-slip-list-data">
            {{ props.row.model }}
            <br />
            <span>
              {{ props.row.vinNo }}
            </span>
          </div>
        </b-table-column>
        <b-table-column
          label="ナンバー"
          field="hasNumberPlate"
          v-slot="props"
          width="75"
        >
          <div class="order-slip-list-data">
            <span v-show="props.row.hasNumberPlate">
              有
              <br />
              <span v-if="props.row.transportOptionNumberPlateCut">
                (要カット)
              </span>
              <span v-else> (外さない) </span>
            </span>
          </div>
        </b-table-column>
        <b-table-column label="備考" v-slot="props" width="230">
          <div class="order-slip-list-data">
            {{ props.row.getRemarks() }}
            <div v-show="props.row.transportRemarks" style="margin-top: 0.8em">
              ※ {{ props.row.transportRemarks }}
            </div>
          </div>
        </b-table-column>
        <b-table-column label="納車日" width="60">
          <div class="order-slip-list-data">
            <br />
          </div>
        </b-table-column>
        <b-table-column label="金額" v-slot="props" width="80">
          <div class="order-slip-list-data" v-if="tabActive == 0">
            {{ props.row.transportActualCost | formatCurrency('\xA5') }}
          </div>
          <div class="order-slip-list-data" v-if="tabActive == 1">
            {{ props.row.transportTotalCost | formatCurrency('\xA5')  }}
          </div>
        </b-table-column>
      </b-table>
    </b-field>
    <div class="has-text-weight-bold is-size-1-125" v-if="tabActive == 0">
      ＊オークション会場引取の場合、車内の搬出券は破棄して下さい。<br />
      ＊ナンバーの項目に要カットとある場合のみ、ナンバーを取り外し弊社までご送付下さい。
      <div class="has-text-weight-bold is-size-1-125">
        ＊確認のため必ず返信FAXをお願いたします。
      </div>
    </div>
    <div class="has-text-weight-bold is-size-1-125" v-if="tabActive == 1">
      ご依頼誠にありがとうございます。<br />
      陸送のご依頼受注いたしました。
      </div>
    <div class="has-text-weight-bold is-size-1-125">
      ＊自走陸送になる場合返信FAX時にお知らせください。 <br/>
      また、別途燃料費がかかった場合ご連絡いただけますと幸いです。
    </div>
  </section>
</template>
<style>
@media print {
  .navbar {
    display: none !important;
  }
}
table th {
  font-size: 0.8em;
}
</style>
<style scoped>
@page {
  size: A4 landscape;
  margin: 10mm;
}
.order-slip {
  margin: 50px 0;
}
@media print {
  .order-slip {
    margin-top: 0;
  }
}
.subinfo {
  font-size: 0.8em;
}
.v-input-memo {
  margin-bottom: 15px;
  margin-left: 35px;
}
.v-icon-memo {
  width: 20px;
  cursor: pointer;
}
.v-input-textarea {
  width: 900px;
  min-height: 72px;
  padding: 2px;
  resize: none;
  overflow: hidden;
  background-color: transparent;
  border: 1.5px solid #315490;
  border-radius: 4px;
  font-size: 1rem;
}
.font-20{
  font-size: 20px;
}
.is-size-1-125 {
  font-size: 1.125rem;
}
</style>
<script>
import moment from 'moment';
export default {
  data: () => ({
    vendor: null,
    user: null,
    auctionVendors: [],
    isShowMemo: false,
    tabActive: 0,
    listIdChecked: [],
  }),
  created() {
    if(this.$route.params.type == 0 ){
      this.vendor = Object.assign({}, this.$store.getters.transportVendorWithItems(this.$route.params.id)); 
      this.listIdChecked = this.$store.getters.getListIdBooking;
      if(this.listIdChecked.length> 0) {
        this.vendor.items = this.vendor.items.filter(item => this.listIdChecked.includes(item.id));
      }
      this.$store.commit('setListIdBooking', []);
    }else{
      this.vendor = this.$store.getters.transportVendorWithCustomer(
        this.$route.params.id
      );
    }
    this.tabActive = this.$route.params.type;
    this.user = this.$store.state.user;
    this.auctionVendors = this.$store.state.auctionVendors;
  },
  computed: {
    today() {
      return moment().format('YYYY/MM/DD');
    },
    transporterName() {
      if(this.tabActive == 0){
        const a = this.$store.getters.transportVendor(this.vendor.id);
        return a ? a.Company.value : this.vendor.name;
      }else{
        const a = this.$store.getters.customerBooking(this.vendor.id);
        return a ? a.customer_name : this.vendor.name;
      }
    },
  },
  methods: {
    posNumber(item) {
      return item.pos ? item.pos : '';
    },
    posAccount(item) {
      return item.postAccount ? item.postAccount + '名義' : '';
    },
    transportTo(item) {
      const to = this.$store.getters.yardVendor(item.transportToId);
      return to
        ? to.Company.value + '' + item.transportToName
        : item.transportToName;
    },
    systemNameYardVendor(item) {
      const to = this.$store.getters.yardVendor(item.transportToId);
      return to ? to.ドロップダウン.value : '';
    },
    conpanyNameYardVendor(item) {
      const to = this.$store.getters.yardVendor(item.transportFromId);
      return to ? to.Company.value : '';
    },
    showMemo() {
      this.isShowMemo = !this.isShowMemo;
    },
    autoResize() {
      let element = this.$refs['textarea'];
      element.style.height = '18px';
      element.style.height = element.scrollHeight + 'px';
    },
  },
};
</script>
